/**
 * External Dependencies
 */
import { createStore } from 'vuex'

/**
 * Internal Dependencies
 */
import account from '@/store/modules/account';
import pdfViewer from '@/store/modules/pdfViewer';

export default createStore({
	modules: {
		account,
		pdfViewer
	}
});
